import { getTransferHistoricPath, isTransferHistoricPath } from "util/v3UxConfig";

/**
 * Target list route after exiting a draft opened from pending transactions or historic.
 * Ticket URLs are usually `/transaction/:id`; combine with Redux `transactions.transactionRoute`
 * (saved when mounting lists) when pathname alone is not enough.
 *
 * @param {string} [pathname] Current location pathname (e.g. from `history.location.pathname`).
 * @param {string} [savedTransactionRoute] `transactions.transactionRoute` from Redux.
 * @returns {"/pendingTransaction/list"|"/transactions/list"|ReturnType<typeof getTransferHistoricPath>}
 */
export default function resolveDraftTransactionListGoBack(pathname, savedTransactionRoute) {
    const pathsToInspect = [pathname, savedTransactionRoute].filter((p) => typeof p === "string" && p.length > 0);

    for (let i = 0; i < pathsToInspect.length; i += 1) {
        const p = pathsToInspect[i];
        if (p.startsWith("/pendingTransaction")) {
            return "/pendingTransaction/list";
        }
        if (p.startsWith("/transactions/list")) {
            return "/transactions/list";
        }
        if (
            isTransferHistoricPath(p) ||
            p.startsWith("/v2/transfer/historic") ||
            p.startsWith("/v3/transfer/historic")
        ) {
            return getTransferHistoricPath();
        }
    }

    return "/transactions/list";
}
